import React, { useContext, useEffect, useState } from "react";
import YourInfo from "./YourInfo";
import Plan from "./Plan";
import BackgroundSidebar from "../assets/images/sidebar_image8.jpg";
import BackgroundSidebarMobile from "../assets/images/bg-sidebar-mobile.svg";
import Step from "./Step";
import Addons from "./Addons";
import Summary from "./Summary";
import Thankyou from "./Thankyou";

import arcadeLogo from "../assets/images/icon-arcade.svg";
import advancedLogo from "../assets/images/icon-advanced.svg";
import proLogo from "../assets/images/icon-pro.svg";

import Login from "../../../../Components/Login";
import Aadhaar from "./Aadhar";
import Education from "./Education";
import DragDropFiles from "./Test";

import Test4 from "./test4";
import { Timer_Context } from "../../../../Context/Timer_context";
import axios from "axios";
import { BASE_URL, INSURANCE_URL } from "../../../../baseurl";
import FormField from "./FormField";
import SectionHeading from "./SectionHeading";
import AadhaarDrop from "./Aadhar_Drop";
import EducationDrop from "./Education_Drop";
import DropFileInput from "./DropFileInput";
import { useFormik } from "formik";
import * as Yup from "yup";

const Form = () => {
  //------------------------------STATES------------------------------

  const [steps, setSteps] = useState([
    { id: 1, title: "PAN Card", active: true },
    { id: 2, title: "Aadhaar Details", active: false },
    { id: 3, title: "Profile Photo", active: false },
    { id: 4, title: "Highest Education Qualification", active: false },
  ]);
  const [stepNumber, setStepNumber] = useState(1);
  const [displayThankyou, setDisplayThankyou] = useState(false);
  const [data, setData] = useState({});

  const formik = useFormik({
    initialValues: {
      Name: data?.Name || "",
      Pan_No: data?.Pan_No || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      Name: Yup.string().required("Name is required"),
      Pan_No: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN Number")
        .required("PAN Number is required"),
    }),
    onSubmit: async (values) => {
      callApi(values, 2);
      setActiveStep(2);
    },
  });

  const formikAadhar = useFormik({
    initialValues: {
      Aadhar_No: data?.Aadhar_No || "",
      Aadhar_Image_Front: data?.Aadhar_Image_Front || null,
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      Aadhar_No: Yup.string()
        .matches(/^[0-9]{12}$/, "Aadhar number must be 12 digits")
        .required("Aadhar number is required"),
      Aadhar_Image_Front: Yup.mixed().required(
        "Aadhar card front image is required"
      ),
    }),
    onSubmit: (values) => {
      callApi(values, 3);
      setActiveStep(3);
    },
  });

  const formikProfile = useFormik({
    initialValues: {
      Profile_Image: data?.Profile_Image || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      Profile_Image: Yup.string().required("Profile image is required"),
    }),
    onSubmit: async (values) => {
      callApi(values, 4);
      setActiveStep(4);
    },
  });

  const formikEducation = useFormik({
    initialValues: {
      Education_value: data?.Education_value || "",
      Education_Image: data?.Education_Image || "",
    },

    validationSchema: Yup.object().shape({
      Education_value: Yup.string().required(
        "Please select at least one option"
      ),
      Education_Image: Yup.string().required("Proof image is required"),
    }),
    onSubmit: async (values) => {
      callApi(values, 1);
      setDisplayThankyou(true);
    },
  });

  const nextStep = () => {
    if (stepNumber === 1) {
      formik.handleSubmit();
    } else if (stepNumber === 2) {
      formikAadhar.handleSubmit();
    } else if (stepNumber === 3) {
      formikProfile.handleSubmit();
    } else if (stepNumber === 4) {
      formikEducation.handleSubmit();
    }
  };

  const onFileChange = async (file, field) => {
    console.log(file, "checkfile");
    try {
      const formData = new FormData();
      formData.append("image", file[0]);
      let res = await axios.post(`${INSURANCE_URL}/image/upload`, formData, {
        headers: {},
      });
      if (res.status == 200) {
        let img = res?.data?.data?.[0]?.Link;
        if (field === "aadhar") {
          formikAadhar?.setFieldValue("Aadhar_Image_Front", img);
        } else if (field === "profile") {
          formikProfile?.setFieldValue("Profile_Image", img);
        } else if (field === "education") {
          formikEducation?.setFieldValue("Education_Image", img);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const callApi = async (values, no) => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.post(`${BASE_URL}/user/ckyc/addData`, values, {
        headers: {
          Authorization: token,
        },
      });
      if (res.status == 200) {
        setStepNumber(no);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const setActiveStep = (id) => {
    setSteps((prevSteps) => {
      return prevSteps.map((step) => {
        if (step.id <= id) {
          return { ...step, active: true };
        } else {
          return { ...step, active: false };
        }
      });
    });
  };

  console.log(formikProfile.errors, "checkformikaadhasr");

  const getCertificateData = async () => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.get(`${BASE_URL}/user/data/getDetails`, {
        headers: {
          Authorization: token,
        },
      });

      if (res.status == 200) {
        setData(res?.data?.data);
        let resData = res?.data?.data;
        console.log(resData);
        if (!resData?.Pan_No) {
          setStepNumber(1);
          setActiveStep(1);
        } else if (!resData?.Aadhar_No) {
          setStepNumber(2);
          setActiveStep(2);
        } else if (!resData?.Profile_Image) {
          setStepNumber(3);
          setActiveStep(3);
        } else if (!resData?.Education_value) {
          setStepNumber(4);
          setActiveStep(4);
        } else if (
          resData?.Education_value &&
          resData?.Profile_Image &&
          resData?.Aadhar_No
        ) {
          setDisplayThankyou(true);
          setActiveStep(4);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getCertificateData();
  }, []);

  return (
    // background-image: linear-gradient(to right, rgba(250,252,254,1), rgba(217,237,237,1));
    <div className="container pt-[40px] m-auto bg_kyc ">
      <div className=" rounded-xl md:p-3 md:flex justify-center w-[100%] mt-[50px]">
        <div className="relative form_sidebar ">
          <div className="flex justify-center mt-8 absolute inset-0 space-x-10 md:space-x-0 md:block md:mt-0 md:pl-6 md:pt-8 md:space-y-7">
            {steps.map((step) => (
              <Step
                key={step.id}
                number={step.id}
                title={step.title}
                active={step.active}
              />
            ))}
          </div>
        </div>

        <div className="flex flex-col justify-between absolute top-40 w-[450px] md:static mb-40 rounded-2xl p-[40px] w-[50%] h-[565px] shadow_form  rounded-tl-none rounded-bl-none rounded-tr-lg rounded-br-lg bg-white ">
          {(displayThankyou && (
            <>
              <Thankyou />
            </>
          )) || (
            <>
              <div>
                {(stepNumber === 1 && (
                  <div>
                    <SectionHeading
                      style={{
                        background: "aliceblue",
                        padding: "12px",
                        borderRadius: "5px",
                      }}
                      title="PAN Card"
                      desc="Submitting your PAN card is necessary for carrying out any financial transactions."
                    />

                    <form>
                      <div className="flex flex-col space-y-6 text-[14px]">
                        <FormField
                          name={"Name"}
                          label={"Name"}
                          value={formik.values?.Name}
                          placeholder={"Enter your full name"}
                          onChangeYourInfo={formik.handleChange}
                          touched={formik.touched.Name}
                          error={formik.errors.Name}
                        />
                        <FormField
                          name={"Pan_No"}
                          label={"PAN Card"}
                          value={formik.values?.Pan_No}
                          placeholder={"PAN Card No."}
                          onChangeYourInfo={formik.handleChange}
                          touched={formik.touched.Pan_No}
                          error={formik.errors.Pan_No}
                        />
                      </div>
                    </form>
                  </div>
                )) ||
                  (stepNumber === 2 && (
                    <div>
                      <SectionHeading
                        style={{
                          background: "aliceblue",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                        title="Aadhaar Card"
                        desc="Submitting your Aadhaar card is essential for facilitating secure and authorized financial transactions."
                      />

                      <form>
                        <div className="flex flex-col space-y-6 text-[14px]">
                          <div>
                            <div className="flex justify-between items-center">
                              <label>Aadhaar Card</label>
                              {formikAadhar.touched.Aadhar_No &&
                                formikAadhar.errors.Aadhar_No && (
                                  <p
                                    className={`font-medium text-[14px] text-[#ed3548]`}
                                  >
                                    {formikAadhar?.errors?.Aadhar_No}
                                  </p>
                                )}
                            </div>
                            <div>
                              <input
                                // onChange={onChangeAadhaar}
                                name="Aadhar_No"
                                type="text"
                                value={formikAadhar.values.Aadhar_No}
                                onChange={formikAadhar.handleChange}
                                onBlur={formikAadhar.handleBlur}
                                className={`font-medium w-full mt-1 p-2 pl-3 rounded-full rounded-lg border text-[#02295a] text-[15px] hover:border-[#02295a] focus:border-white focus:ring-[#bfe2fd] w-[50%] p-[14px] mt-[10px]`}
                                placeholder="Enter Aadhar Card No."
                              />
                              {formikAadhar.touched.Aadhar_Image_Front &&
                                formikAadhar.errors.Aadhar_Image_Front && (
                                  <p
                                    className={`font-medium text-right text-[14px] text-[#ed3548] mt-4`}
                                  >
                                    {formikAadhar?.errors?.Aadhar_Image_Front}
                                  </p>
                                )}
                              <AadhaarDrop
                                onFileChange={(files) =>
                                  onFileChange(files, "aadhar")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )) ||
                  (stepNumber === 3 && (
                    <div className="box">
                      <SectionHeading
                        style={{
                          background: "aliceblue",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                        title="Profile Photo"
                        desc="Take a moment to personalize your account by uploading a profile photo."
                      />
                      <h2 className="header"></h2>
                      {formikProfile.touched.Profile_Image &&
                        formikProfile.errors.Profile_Image && (
                          <p
                            className={`font-medium text-right text-[14px] text-[#ed3548] mb-4 mr-20`}
                          >
                            {formikProfile.errors.Profile_Image}
                          </p>
                        )}
                      <DropFileInput
                        onFileChange={(files) => onFileChange(files, "profile")}
                      />
                    </div>
                  )) ||
                  (stepNumber === 4 && (
                    <div>
                      <SectionHeading
                        style={{
                          background: "aliceblue",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                        title="Highest Education Qualification"
                        desc="Providing details of your highest education qualification is crucial for us to better understand your academic background"
                      />

                      <form>
                        <div className="flex flex-col space-y-6 text-[14px]">
                          <div>
                            <div className="flex justify-between items-center">
                              <label>Highest Education Qualification</label>
                              {formikEducation.touched.Education_value &&
                                formikEducation.errors.Education_value && (
                                  <p
                                    className={`font-medium text-right text-[14px] text-[#ed3548] mb-4 mr-20`}
                                  >
                                    {formikEducation.errors.Education_value}
                                  </p>
                                )}
                            </div>
                            <div>
                              <select
                                name="Education_value"
                                value={formikEducation.values.Education_value}
                                onChange={formikEducation.handleChange}
                                onBlur={formikEducation.handleBlur}
                                id="education"
                                className={`font-medium w-full mt-1 p-2 pl-3 rounded-full rounded-lg border text-[#02295a] text-[15px] hover:border-[#02295a] focus:border-white focus:ring-[#bfe2fd] w-[50%] p-[14px] mt-[10px]`}
                                // onChange={onChangeEducation}
                              >
                                <option value="10th Pass">10th Pass</option>
                                <option value="12th Pass">12th Pass</option>
                                <option value="Graduate">Graduate</option>
                                <option value="Post Graduate">
                                  Post Graduate
                                </option>
                              </select>
                              {formikEducation.touched.Education_Image &&
                                formikEducation.errors.Education_Image && (
                                  <p
                                    className={`font-medium text-right text-[14px] text-[#ed3548] mt-4`}
                                  >
                                    {formikEducation.errors.Education_Image}
                                  </p>
                                )}
                              <EducationDrop
                                onFileChange={(files) =>
                                  onFileChange(files, "education")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  ))}
              </div>
              <div className="flex justify-between fixed px-16 bottom-0 left-0 w-full bg-white p-5 md:static md:p-0 md:static items-center w-[700px]]">
                {/* {stepNumber != 1 && (
              <div
                onClick={prevStep}
                className={`font-medium text-[#9699ab] cursor-pointer transition duration-100 hover:text-[#02295a] ${goBackVisible}`}
              >
                Go back
              </div>
            )} */}
                <button
                  onClick={() =>
                    setStepNumber((pre) => (pre >= 2 ? pre - 1 : pre))
                  }
                  // className={`font-medium text-[#9699ab] select-none cursor-pointer transition duration-100 hover:text-[#02295a] ${goBackVisible}`}
                >
                  Go back
                </button>
                {stepNumber === 4 ? (
                  <div
                    onClick={nextStep}
                    className="font-medium bg-[#473dff] select-none text-white py-3 px-5 rounded-lg cursor-pointer transition duration-100 hover:opacity-90"
                  >
                    Confirm
                  </div>
                ) : (
                  <div
                    onClick={nextStep}
                    className="font-medium bg-[#02295a] select-none text-white py-3 px-5 rounded-lg cursor-pointer transition duration-100 hover:opacity-90"
                  >
                    Next Step
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Form;
